module.exports = __webpack_public_path__ + "assets/img/not_data_tips-4c0bdd26.png";